import React from "react";
import FormComponent from "../Form/FormComponent";
import CloseIcon from "@material-ui/icons/Close";

export default props => {
  const renderContent = props => {
    return (
      <FormComponent
        formConfig={props.formConfig}
        formValidation={props.formValidation}
        modalClose={props.modalClose}
        query={props.query}
        query1={props.query1}
        params1={props.params1}
        params2={props.params2}
        params={props.params}
        onButton={props.onButton}
        getData={props.getData}
        updateData={props.updateData}
        storeArray={props.storeArray}
        className={props.className}
        buttonName={props.buttonName}
        message={props.message}
        params3={props.params3}
      />
    );
  };
  return (
    <div className={props.className}>
      <div>
        <div className="formHeader">
          <div
            style={{
              color: "#0456d9",
              fontSize: "18px",
              fontFamily: "inherit"
            }}
          >
            {props.title}
          </div>
          <div>
            <CloseIcon
              fontSize="small"
              onClick={props.modalClose}
              style={{ cursor: "pointer", color: "grey" }}
            />
          </div>
        </div>
      </div>
      {renderContent(props)}
    </div>
  );
};
